import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from 'react-i18next';

// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import travelimg from '../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import { event } from "jquery";
import $ from 'jquery';

const { config } = require('../api/api');


function HotelPayment({ initialTime = 15 * 60 }){
  
const [vendorKey, setVendorkey] = useState('');
const [token, setToken] = useState(false);
const[fname,setFname]=useState('');
const [timeExpired, setTimeExpired] = useState(false);
const[lname,setLname]=useState('');
const[parseData,setparseData]=useState('');
const[bookingpage,setbookingpage]=useState([]);
    const [priceInfo,setPriceInfo]=useState(null);
     const [allInformation,setAllInformation]=useState(null);
       const [imgDetails,setImgDetails]=useState(null);
       const [roomDetails,setRoomDetails]=useState([]);
       const[hotelDetails,setHotelDetails]=useState(null);
       const [timeLeft, setTimeLeft] =useState(() => {
        const stored = sessionStorage.getItem('offerTimer');
        return stored ? Number(stored) : 15 * 60;
      });
    

     useEffect(() => {
        if (timeLeft <= 0){
          setTimeExpired(true);
          return;
        }
         
        const timer = setInterval(() => {
          setTimeLeft((prevTime) =>{
            const updated =prevTime - 1;
            sessionStorage.setItem('offerTimer', updated);
        return updated;
      });
        }, 1000);
        return () => clearInterval(timer);
      }, [timeLeft]);
    
      const handleRestart = () => {
        sessionStorage.setItem("offerTimer", 15 * 60);
        window.location.href="/hotel-search" 
      };
    
    
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
      };
    

    
    const base_url = config.baseURL;
    const redirect_url = config.redirectURL;
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    const [loading, setLoading] = useState(true);

    const { t } = useTranslation();
    const stgurl="https://stg-api.superjetom.com"


    useEffect(() => {
    
        const postvData = { organization_name: "Superjet" };
        debugger
    
        if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
    
          debugger
          fetch(base_url + '/create_organization', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postvData),
          })
            .then(response => response.json())
            .then(data => {
              setVendorkey(data.result[0].vendor_key);
            })
            .catch(error => {
              console.error('Error posting data:', error);
            });
    
    
        }
      }, [vendorKey]);


       useEffect(()=>{
          const storedData = Cookies.get('auth_key');
          if (storedData !== undefined) {
            const storedtoken = JSON.parse(storedData);
            setToken(storedtoken);
          }
          else {
            // alert("token expired");
            // window.location.href='/';
          }
        })
       useEffect(()=>{
    
              const getpricing=async()=>{
              const offer_id=sessionStorage.getItem("Offer_id");
              const hotel_offer_data={
                  etmtoken:token,
                  offer_id:offer_id
                  }
               try {
                  const response =await fetch(`${base_url}/hotel_pricing`, {
                     method: "POST",
                     headers: {
                       "Authorization": "Bearer "+ vendorKey,
                       "Content-Type": "application/json"
                     },
                     body: JSON.stringify(hotel_offer_data)
                   });
                   if (!response.ok) {
                     console.log("http response status : ", response.status)
                   }
                   else {
                     const data = await  response.json();
                     if(data.message==="success"){
                      debugger
                     setPriceInfo(data.result.price_per_currency);
                     
                     setImgDetails(data.result.image);
                     const {rooms,...filter}=data.result;
                     setAllInformation(filter);
                     setRoomDetails(rooms);
                     setHotelDetails(data.result.hotel);
                     }
                   }
                 }
                 catch (err) {
                   console.log("Hotel Show Offer API Err : ", err);
                   setLoading(false);
                      }
                      setLoading(false);
                    }
                  if(vendorKey && token){
                    getpricing()
                  }
                    },[vendorKey,token]) 

const storedHotels = sessionStorage.getItem("hotelList");
if (storedHotels) {
  const hotelList = JSON.parse(storedHotels); 
  setbookingpage(hotelList);

}


  useEffect(() => {
    debugger
    const hotel= sessionStorage.getItem("hotelpayment");
      if (hotel) {
        const parseData=hotel?JSON.parse(hotel):null;
        setparseData(parseData)
          setFname(parseData?.rooms[0]?.guests[0]?.firstname); 
           setLname(parseData?.rooms[0]?.guests[0]?.lastname)

                }
            }, []);

    
    const getpayment= async ()=>{
     
      debugger 
      try {
      
          const response =await fetch(stgurl + "/orders", {
            method: "POST",
            headers: {
              "Authorization": "Bearer "+ vendorKey,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(parseData)
          });
          if (!response.ok) {
            console.log("http response status : ", response.status)
          }
          else {
            const data = await  response.json();
            if(data.message==="success"){
            // setHotellist(data.result.data.hotels);
            }
          }
        }
        catch (err) {
          console.log("Hotel Show Offer API Err : ", err);
             }
    }
    const StarRating = ({ rating, totalStars = 5 }) => {
      debugger
      const filledStars = Math.round(rating);
      const emptyStars = totalStars - filledStars;
      const filledArr=new Array(filledStars);
      filledArr.fill("fullStar");
      const emptyArr=new Array(emptyStars);
      emptyArr.fill("fullStar");
      return (
          <div className="star-rating" style={{ display: 'flex', padding: '0' }}>
              {filledArr.map((_, index) => (
                  <span
                      key={`filled-${index}`}
                      //   onClick={() => handleStarClick(index)}
                      style={{ color: 'gold', cursor: 'pointer' }}
                  >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                          <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                  </span>
              ))}
              {emptyArr.map((_, index) => (
                  <span
                      key={`empty-${index}`}
                      //   onClick={() => handleStarClick(filledStars + index)}
                      style={{ color: 'gray', cursor: 'pointer' }}
                  >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
                          <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                      </svg>
                  </span>
              ))}
          </div>
      );

  }  

  const handleBackBtn=(e)=>{
    e.preventDefault();
    window.location.href="/hotel-booking"
  }

   return (
    <Fragment>
        
        <div className="header_section1">

<Navbar />


<div className="container-fluid bg-breadcrumb">
    <div className="container text-center py-5">
        <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'e-Hotel Details' : 'تفاصيل الفندق الإلكتروني\n'}</h3>
    </div>
</div>


</div>
            <div className="features_section">
  {/* {bookingpage.map((item,index)=>( */}
                <div className="container">

                <div className="row p-4">
            <div className="col-md-1">
            </div>
            <div className="col-md-6">
            <div className="card p-2 shadow"
              style={{
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0" >Guests</h2>
            </div>
            <div className="card p-2 shadow mt-0">
                <table className="table table-bordered ">
                    <thead style={{backgroundColor:"#f4f6fb"}}>
                <tr>
                    <td>Room</td>
                    <td>Guests</td>
                </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Comfort Cottage</td>
                        
                        
                            <td>
                                <div className="d-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                  </svg>
                           <span className="mx-1"> {fname} {lname}</span>
                            </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="card p-2 shadow mt-3"
              style={{
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
                <div className="d-flex justify-content-end">
              <h3 className="card-title p-1">Order cost : {priceInfo?.USD?.total}.00 USD</h3>
              </div>
            </div>
            <div className="card p-3 shadow">
            <div className="d-flex justify-content-between">
                <button className="btn-primary text-white my-3 py-1" style={{ height: '35px', width: '100px' }}  onClick={handleBackBtn}>
                  Back
                </button>
                <button className="btn-primary text-white my-3 py-1"    onClick={(e)=>{getpayment()}} style={{ height: '35px', width: '100px' }}>
                  Buy
                </button>
              </div>
              </div>
            </div>
            <div className="col-md-4">
            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0" >Booking details</h2>
              </div>

            <div className="card p-3 shadow">
              <div className="d-flex flex-column" >
                <h3 class="fw-bold p-0">{hotelDetails?.name}</h3>
                
                {hotelDetails!==null?
                <StarRating rating={hotelDetails?.stars} />:""}
              </div>
              <p>{hotelDetails?.address}</p>
              <div style={{
                height: "150px",
                width: "100%",
                overflow: "hidden",
                 }}>
                <img src={imgDetails?.url} class="w-100 h-20 object-fit-cover" alt=""></img>
              </div>
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <th >Check-in</th>
                    <td>{allInformation!==null?allInformation?.stay_dates?.from:""}</td>
                  </tr>
                  <tr>
                    <th >Check-out</th>
                    <td>{allInformation!==null?allInformation?.stay_dates?.to:""}</td>
                  </tr>
                  <tr>
                    <th scope="row">Nights</th>
                    <td>1</td>
                  </tr>
                  <tr>
                    <th scope="row">Guests</th>
                    <td>1</td>
                  </tr>
                  <tr>
                    <th scope="row">Rooms</th>
                    <td>1</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <h3>Order cost : {priceInfo?.USD?.total}.00 dollars</h3>
              </div>
              </div>

            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <div className="d-flex">
                <h2 className="card-title p-0">Cancellation Policy</h2>
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="skyblue" class="bi bi-exclamation-circle-fill ml-2 mt-1" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                </svg>

              </div>
              <div className="border border-info rounded p-3 bg-light">
                <h3>Attention!</h3>
                <p>{allInformation!==null?allInformation?.cancel_policy?.description:""}</p>
              </div>
              <span className="mt-1 mx-2"><span style={{ color: "red" }}>*</span> Time Zone according to your settings is (UTC +0)</span>
            </div>
            <div className="mt-4">
              <h3 style={{ fontSize: "20px" }}>{formatTime(timeLeft)}</h3>
              <span>Pay for your order within 15 minutes</span>


              {timeExpired && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            }}
          >
            <h4>⏰ Current session is over.</h4>
            <p>Please update your search request</p>
            <button onClick={handleRestart} className="btn mt-3">
              Repeat the search
            </button>
          </div>
        </div>
      )}

            </div>
          </div>

            <div className="col-md-1">
                </div>

        </div>
                </div>
   {/* ))}  */}
   </div>
   <Footer />
   {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
   )
}
export default HotelPayment;

